/* BB lux (Claude, okt 2026)
   1) Grå yta: första produktbilden (grid + produktsida) får ALLTID grå yta via CSS – ingen kontroll, inget JavaScript
      behövs, fungerar på alla enheter. Bara hover-bilden (bild 2 i griden) kontrolleras, så att miljöbilder inte gråtonas.
   2) Klick på färgprick byter bild, hela titeln (namn + yta), pris och länk i griden utan sidladdning.
   3) "+N" fäller ut resterande färgprickar. Mobil: priset döljs medan de är utfällda, "×" fäller in.
   4) Mobil: max 3 prickar, färre om priset är långt (minst den valda), resten bakom "+N". */
(function () {
  if (window.__bbLux) return;
  window.__bbLux = true;
  var SEL = 'img.lux-hover.lux-blend';
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var MAX_MOBILE_DOTS = 3;
  var WHITE = 245;
  var canvas = document.createElement('canvas');
  var ctx = null;

  function noBlend(img) {
    img.classList.add('lux-noblend');
    img.classList.add('lux-cover');
  }

  function sample(img) {
    var w = 48;
    var h = Math.max(2, Math.round(w * img.naturalHeight / img.naturalWidth));
    canvas.width = w; canvas.height = h;
    ctx = ctx || canvas.getContext('2d', { willReadFrequently: true });
    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(img, 0, 0, w, h);
    var pts = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2], [w >> 1, 1]];
    var white = true;
    for (var i = 0; i < pts.length; i++) {
      var d = ctx.getImageData(pts[i][0], pts[i][1], 1, 1).data;
      if (d[3] < 250) return 'unknown';
      if (d[0] < WHITE || d[1] < WHITE || d[2] < WHITE) white = false;
    }
    return white ? 'white' : 'other';
  }

  function check(img) {
    if (!img.matches(SEL) || img.dataset.luxChecked) return;
    if (!img.complete || !img.naturalWidth) return;
    img.dataset.luxChecked = 'pending';
    var tries = +(img.dataset.luxTries || 0);
    var run = function () {
      var res;
      try { res = sample(img); } catch (e) { res = 'other'; }
      if (res === 'unknown') {
        delete img.dataset.luxChecked;
        if (tries < 4) {
          img.dataset.luxTries = tries + 1;
          setTimeout(function () { check(img); }, 400);
        }
        return;
      }
      img.dataset.luxChecked = res;
      if (res === 'other') noBlend(img);
    };
    if (img.decode) img.decode().then(run, run); else run();
  }

  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

  /* Mobil: max 3 prickar, färre om priset tar plats */
  function fitOne(bottom) {
    var sw = bottom.querySelector('.lux-swatches');
    if (!sw) return;
    var dots = Array.prototype.slice.call(sw.querySelectorAll('.lux-swatch'));
    var more = sw.querySelector('.lux-swatch__more');
    if (!MOBILE.matches) {
      if (bottom.hasAttribute('data-fit')) bottom.removeAttribute('data-fit');
      dots.forEach(function (d) { d.classList.remove('m-hide'); });
      if (more) { more.classList.remove('m-show'); setText(more, more.getAttribute('data-desk')); }
      return;
    }
    if (bottom.classList.contains('is-open')) return;
    var price = bottom.querySelector('.price');
    var n = dots.length;
    var dotW = 20, moreW = 24, gap = 10;
    var avail = bottom.clientWidth - (price ? price.scrollWidth : 0) - gap;
    var k = Math.min(n, MAX_MOBILE_DOTS);
    var need = k * dotW + (k < n ? moreW : 0);
    if (need > avail) {
      k = Math.floor((avail - moreW) / dotW);
      k = Math.max(1, Math.min(k, MAX_MOBILE_DOTS, n - 1));
    }
    dots.forEach(function (d, i) { d.classList.toggle('m-hide', i >= k); });
    if (more) {
      more.classList.toggle('m-show', k < n);
      setText(more, '+' + (n - k));
    }
    if (!bottom.hasAttribute('data-fit')) bottom.setAttribute('data-fit', '1');
  }

  var fitTimer = null;
  function fitAll() {
    if (fitTimer) return;
    fitTimer = setTimeout(function () {
      fitTimer = null;
      document.querySelectorAll('.lux-card__bottom').forEach(fitOne);
    }, 30);
  }

  function closeBottom(bottom) {
    bottom.classList.remove('is-open');
    var sw = bottom.querySelector('.lux-swatches');
    if (sw) sw.classList.remove('is-open');
    var more = bottom.querySelector('.lux-swatch__more');
    if (more) more.setAttribute('aria-expanded', 'false');
    fitOne(bottom);
  }

  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') check(t);
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var more = e.target.closest('.lux-swatch__more');
    if (more) {
      e.preventDefault();
      var wrap = more.closest('.lux-swatches');
      var b = more.closest('.lux-card__bottom');
      if (wrap) wrap.classList.add('is-open');
      if (b) b.classList.add('is-open');
      more.setAttribute('aria-expanded', 'true');
      return;
    }

    var less = e.target.closest('.lux-swatch__less');
    if (less) {
      e.preventDefault();
      var b2 = less.closest('.lux-card__bottom');
      if (b2) closeBottom(b2);
      return;
    }

    var a = e.target.closest('.lux-swatch');
    if (!a) return;
    var card = a.closest('.lux-card');
    var tpl = a.querySelector('template');
    if (!card || !tpl) return;
    e.preventDefault();
    var bottom = card.querySelector('.lux-card__bottom');
    if (a.classList.contains('is-current')) {
      if (bottom && MOBILE.matches && bottom.classList.contains('is-open')) closeBottom(bottom);
      return;
    }

    var frag = tpl.content;
    var href = a.getAttribute('href');
    var media = card.querySelector('.lux-card__media');
    var newMedia = frag.querySelector('[data-lux-media]');
    if (media && newMedia) {
      media.innerHTML = newMedia.innerHTML;
      media.setAttribute('href', href);
      media.querySelectorAll('img').forEach(function (img) { if (img.complete) check(img); });
    }
    var price = card.querySelector('.lux-card__bottom .price');
    var newPrice = frag.querySelector('[data-lux-price] .price');
    if (price && newPrice) price.replaceWith(newPrice.cloneNode(true));
    var name = a.getAttribute('data-name');
    card.querySelectorAll('.lux-card__title a').forEach(function (l) {
      l.setAttribute('href', href);
      if (name) setText(l, name);
    });
    var sub = card.querySelector('.lux-card__sub');
    if (sub) setText(sub, a.getAttribute('data-sub') || '');
    card.querySelectorAll('.lux-swatch').forEach(function (s) {
      s.classList.remove('is-current');
      s.removeAttribute('aria-current');
    });
    a.classList.add('is-current');
    a.setAttribute('aria-current', 'true');

    if (bottom) {
      if (MOBILE.matches) {
        var sw = bottom.querySelector('.lux-swatches');
        if (sw && a.parentNode === sw) sw.insertBefore(a, sw.firstChild);
      }
      if (MOBILE.matches && bottom.classList.contains('is-open')) closeBottom(bottom);
      else fitOne(bottom);
    }
  });

  function scan() { document.querySelectorAll(SEL).forEach(check); fitAll(); }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  window.addEventListener('pageshow', scan);
  window.addEventListener('resize', fitAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  if (MOBILE.addEventListener) MOBILE.addEventListener('change', fitAll);
  if (window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.nodeType === 1 && t.closest && t.closest('.lux-swatch__more')) continue;
        fitAll(); return;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
